/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Price_LinkInputs */

const es_l7_price_link = /** @type {(inputs: L7_Price_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver el desglose completo`)
};

const gl_l7_price_link = /** @type {(inputs: L7_Price_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver o desglose completo`)
};

const en_l7_price_link = /** @type {(inputs: L7_Price_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the full breakdown`)
};

/**
* | output |
* | --- |
* | "See the full breakdown" |
*
* @param {L7_Price_LinkInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_price_link = /** @type {((inputs?: L7_Price_LinkInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Price_LinkInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_price_link(inputs)
	if (locale === "en") return en_l7_price_link(inputs)
	return es_l7_price_link(inputs)
});